var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.files
    ? _c(
        "ul",
        { staticClass: "sector-post__files" },
        _vm._l(_vm.files, function (file) {
          return _c("li", [
            _c(
              "button",
              {
                staticClass: "download",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.handleFileDownload(file.uuid, file.filename)
                  },
                },
              },
              [
                _vm.$wait.is(`downloading-file-${file.uuid}`)
                  ? _c("Spinner", { attrs: { height: 13, width: 13 } })
                  : _c("SvgIcon", {
                      staticClass: "download__icon",
                      attrs: { icon: "download" },
                    }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "download__title",
                  domProps: { textContent: _vm._s(file.filename) },
                }),
                _vm._v(" "),
                file.filetype
                  ? _c("span", { staticClass: "download__mime sector" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.formattedFileType(file.filetype)) +
                          "\n            "
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }